<template>
    <div class="event">
        <div class="content">
            <div class="summary">
                <div class="date" style="width: 100%">
                    <div style="float: left">{{ event.when }}</div>
                    <div style="float: right">{{ event.date.split(' ')[0] }}</div>
                </div>
                <div class="text">
                    <a :href=event.url target="_blank" rel="noopener noreferrer" style="display: table-row">
                        <div style="display: table-cell; width: 100%">
                            <span v-if="isHot" class="hot"><i class="icon icon-fire"></i></span>
                            <span class="direction-from">{{ event.from }}</span>
                            <Direction v-bind:direction=event.direction />
                            <span class="flag">{{ event.to_flag }}</span>
                            <span class="direction-to">{{ event.to }}</span>
                            <span class="connections">{{ event.connections }}</span>
                        </div>
                        <div style="display: table-cell; min-width: 90px">
                            <span class="price"><i class="icon icon-rouble"></i> {{ event.price }}</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Direction from './Direction';

  export default {
    name: 'Event',
    props: {
      event: Object
    },
    computed: {
      isHot: function() {
        return ((Date.now() / 1000) + 2 * 24 * 3600) > this.event.when_end
      }
    },
    components: {
      Direction
    }
  }
</script>

<style scoped>
    .ui.feed > .event > .content .summary > .date {
        margin: 0;
    }

    .direction-from {
        min-width: 100px;
        /*display: inline-block;*/
    }

    .direction-to {
        /*display: inline-block;*/
        min-width: 150px;
        margin-right: 20px;
    }

    .price {
        /*display: inline-block;*/
        color: #CF5318;
        float: right;
        margin-right: 10px;
    }

    .hot {
        color: #FB7D25;
    }

    .connections {
        color: #444;
        font-weight: initial;
        font-size: 0.9em;
        /*margin-left: 20px;*/
        display: inline-block;
    }

    .flag {
        margin-left: 5px;
        margin-right: 5px;
    }
</style>